export enum FilterOffersByType {
  ALL_CARDS = 'ALL_CARDS',
  NO_ANNUAL_FEE = 'NO_ANNUAL_FEE',
  HAS_INTRO_OFFER = 'HAS_INTRO_OFFER',
}

export enum SortOffersByType {
  FEATURED = 'FEATURED',
  HIGHEST_RATING = 'HIGHEST_RATING',
  LOWEST_ANNUAL_FEE = 'LOWEST_ANNUAL_FEE',
  LOWEST_APR = 'LOWEST_APR',
}

export enum FilterType {
  CARD_FEATURE = 'cardFeatureFilter',
  ISSUER = 'issuerFilter',
  CREDIT_RANGE = 'creditRangeFilter',
  SORT_BY = 'sortBy',
}

export const SORT_BY_TO_EVENT_MAP = {
  [SortOffersByType.FEATURED]: 'featured',
  [SortOffersByType.HIGHEST_RATING]: 'rating',
  [SortOffersByType.LOWEST_ANNUAL_FEE]: 'annual_fee',
  [SortOffersByType.LOWEST_APR]: 'apr',
};
